import { render, staticRenderFns } from "./RDataProductCard.vue?vue&type=template&id=0ffa3902&scoped=true&"
import script from "./RDataProductCard.vue?vue&type=script&lang=js&"
export * from "./RDataProductCard.vue?vue&type=script&lang=js&"
import style0 from "./RDataProductCard.vue?vue&type=style&index=0&id=0ffa3902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffa3902",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
